import { render, staticRenderFns } from "./ebookLearning.vue?vue&type=template&id=42d47eba&scoped=true"
import script from "./ebookLearning.vue?vue&type=script&lang=js"
export * from "./ebookLearning.vue?vue&type=script&lang=js"
import style0 from "./ebookLearning.vue?vue&type=style&index=0&id=42d47eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d47eba",
  null
  
)

export default component.exports